import { createSelector } from '@ngrx/store';

import { AppState } from '../appstate.model';

export const selectAccessFeature = (state: AppState) => state.access;

export const selectAccessToken = createSelector(selectAccessFeature, accessState => accessState);
